// propertyTypeSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPropertyType, IPropertyTypeInitialState } from "./propertyTypeModal";
import {
  activeInactivePropertyType,
  createPropertyType,
  deletePropertyType,
  getAllActivePropertyTypes,
  getAllPropertyTypes,
  getPropertyTypeByID,
  propertyTypeImageUpload,
  updatePropertyType,
} from "./services/propertyType.service";

const initialState: IPropertyTypeInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  PropertyTypeID: null,
  PropertyTypeList: [],
  PropertyTypeDetail: {
    ID: null,
    Title: "",
    ImageUpload: "",
    IsActive: 1,
  },
};

const propertyTypeSlice = createSlice({
  name: "propertyType",
  initialState,
  reducers: {
    clearPropertyTypeDetails: (state) => {
      state.PropertyTypeDetail = initialState.PropertyTypeDetail;
    },
    setPropertyTypeID: (state, action) => {
      state.PropertyTypeID = action.payload;
    },
    clearPropertyTypeID: (state) => {
      state.PropertyTypeID = initialState.PropertyTypeID;
    },
  },
  extraReducers: (builder) => {
    // Get All Property Types
    builder.addCase(getAllPropertyTypes.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllPropertyTypes.fulfilled,
      (state, action: PayloadAction<IPropertyType[]>) => {
        state.loading = false;
        state.PropertyTypeList = action.payload || [];
      },
    );
    builder.addCase(getAllPropertyTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PropertyTypeList = [];
    });

    // Create Property Type
    builder.addCase(createPropertyType.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createPropertyType.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createPropertyType.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Update Property Type
    builder.addCase(updatePropertyType.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updatePropertyType.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updatePropertyType.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Delete Property Type
    builder.addCase(deletePropertyType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deletePropertyType.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deletePropertyType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Get Property Type By ID
    builder.addCase(getPropertyTypeByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getPropertyTypeByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.PropertyTypeDetail = action.payload;
    });
    builder.addCase(getPropertyTypeByID.rejected, (state, action) => {
      state.formLoading = false;
      state.PropertyTypeDetail = initialState.PropertyTypeDetail;
      state.error = action.error.message || "Something went wrong";
    });

    // Get All Active Property Types
    builder.addCase(getAllActivePropertyTypes.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActivePropertyTypes.fulfilled,
      (state, action: PayloadAction<IPropertyType[]>) => {
        state.loading = false;
        state.PropertyTypeList = action.payload || [];
      },
    );
    builder.addCase(getAllActivePropertyTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PropertyTypeList = [];
    });

    // Active/Inactive Property Type
    builder.addCase(activeInactivePropertyType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(activeInactivePropertyType.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activeInactivePropertyType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Image Upload
    builder.addCase(propertyTypeImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(propertyTypeImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(propertyTypeImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearPropertyTypeDetails,
  clearPropertyTypeID,
  setPropertyTypeID,
} = propertyTypeSlice.actions;
export default propertyTypeSlice.reducer;
